import { getEkardoApolloClient } from '@netfront/common-library';
import {
  IContentPage,
  IGetContentPageByUrlQueryGraphQLResponse,
  IGetContentPageByUrlQueryVariables,
  GET_CONTENT_PAGE_BY_URL_QUERY,
  ISearchContentGroupsQueryGraphQLResponse,
  ISearchContentGroupsQueryVariables,
  SEARCH_CONTENT_GROUPS_QUERY,
} from '@netfront/ekardo-content-library';
import { GetStaticPathsResult, GetStaticPropsContext, NextPage } from 'next';
import { ParsedUrlQuery } from 'querystring';

import { BlogDetailPage } from '../../components';
import { STATIC_PAGE_REGENERATION_TIME_IN_SECONDS } from '../../constants';

interface BlogDetailNextPageProps {
  contentPage: IContentPage;
}

const BlogDetailNextPage: NextPage<BlogDetailNextPageProps> = ({ contentPage }) => {
  return <BlogDetailPage contentPage={contentPage} />;
};

export async function getStaticPaths(): Promise<GetStaticPathsResult> {
  const client = getEkardoApolloClient({
    product: 'KANZI',
  });

  const {
    data: {
      contentGroup: { searchContentGroups },
    },
  } = await client.query<ISearchContentGroupsQueryGraphQLResponse, ISearchContentGroupsQueryVariables>({
    query: SEARCH_CONTENT_GROUPS_QUERY,
    variables: {
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      shouldIncludeAssetPresignedUrl: true,
      type: 'BLOG',
    },
  });

  const [contentPages] = searchContentGroups.map((contentGroup) => contentGroup.contentPages);

  const paths = contentPages.filter(({ status }) => status === 'PUBLISHED').map(({ url: pageUrl }) => ({
    params: {
      pageUrl,
    },
  }));

  return {
    fallback: false,
    paths,
  };
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const client = getEkardoApolloClient({
    product: 'KANZI',
  });

  const { pageUrl } = context.params as ParsedUrlQuery;

  const {
    data: {
      contentPage: { getContentPageByUrl: contentPage },
    },
  } = await client.query<IGetContentPageByUrlQueryGraphQLResponse, IGetContentPageByUrlQueryVariables>({
    query: GET_CONTENT_PAGE_BY_URL_QUERY,
    variables: {
      contentPageUrl: String(pageUrl),
      incrementStats: false,
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      withAnswers: false,
    },
  });

  return {
    props: {
      contentPage,
    },
    revalidate: STATIC_PAGE_REGENERATION_TIME_IN_SECONDS,
  };
}

// eslint-disable-next-line import/no-default-export
export default BlogDetailNextPage;
